// If a search has fewer than 100 real matches, pad the grid up to 100 with best-selling
// products (deduped against what's already shown) so the page doesn't look sparse. Prefers
// best-sellers scoped to the same vehicle as the current search (or, failing that, the
// persistently-remembered vehicle from assets/vehicle-memory-bar.js) over generic sitewide
// best-sellers, so padding still feels relevant to what the shopper is actually looking for --
// falls back to sitewide only when no vehicle context is available at all.
// This script is only loaded at all when search.results_count < 100 (see templates/search.
// liquid), which -- since results paginate at 100/page -- guarantees there's exactly one page,
// so there's no "is this the last page" edge case to worry about here. Filtering via assets/
// category-brand-filters.js replaces the grid entirely with its own real result set afterward,
// so padding running once up front is harmless (just gets overwritten).
(function(){
  const TARGET_COUNT = 100;
  const grid = document.getElementById('es-grid');
  if (!grid) return;

  // The product card include nests its OWN inner ".product-item" div inside this grid's outer
  // wrapper div of the same class, so a raw querySelectorAll('.product-item').length silently
  // double-counts every real product -- always count by unique product handle instead.
  function existingHandles(){
    return new Set(Array.from(grid.querySelectorAll('.product-item a[href*="/products/"]')).map(a => {
      const m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
      return m ? m[1] : null;
    }).filter(Boolean));
  }

  function vehicleScopedSources(){
    const sources = [];
    const ctx = document.getElementById('es-ctx');
    const terms = ctx ? (ctx.getAttribute('data-search-terms') || '') : '';
    const tagMatches = Array.from(terms.matchAll(/tag:"([^"]+)"|tag:(\S+)/g)).map(m => (m[1] || m[2] || '').toLowerCase());
    if (tagMatches.length){
      sources.push(`/collections/all/${tagMatches.map(t => encodeURIComponent(t)).join('+')}?sort_by=best-selling`);
    }
    try {
      const remembered = JSON.parse(localStorage.getItem('esSelectedVehicle') || 'null');
      if (remembered && remembered.url && remembered.url.indexOf('/collections/') === 0) {
        sources.push(remembered.url + '?sort_by=best-selling');
      }
    } catch (_) {}
    sources.push('/collections/all?sort_by=best-selling'); // final fallback: sitewide best-sellers
    return sources;
  }

  // 2026-10-29: a Facebook commenter searched for their car and "none of the products shown
  // were for their car" -- a rare-car search returns a handful of real matches and this script
  // filled the rest with sitewide best-sellers (mostly Golf parts) that looked like results.
  // Fillers now sit under a clear label so they never read as matches for the search.
  let dividerAdded = false;
  function addDivider(){
    if (dividerAdded) return;
    dividerAdded = true;
    const d = document.createElement('div');
    d.className = 'es-pad-divider';
    d.style.cssText = 'flex:0 0 100%;width:100%;clear:both;margin:18px 0 10px;padding-top:14px;border-top:1px solid #e5e5e5;font-size:12px;letter-spacing:.12em;text-transform:uppercase;color:#888;';
    d.textContent = 'Popular products';
    grid.appendChild(d);
  }

  async function fetchAndAppend(baseUrl, have, count){
    const parser = new DOMParser();
    for (let page = 1; page <= 3 && count < TARGET_COUNT; page++){
      const sep = baseUrl.indexOf('?') !== -1 ? '&' : '?';
      let res;
      try { res = await fetch(`${baseUrl}${sep}page=${page}`, { cache: 'no-store' }); }
      catch (_) { break; }
      if (!res.ok) break;
      const doc = parser.parseFromString(await res.text(), 'text/html');
      const items = Array.from(doc.querySelectorAll('#es-grid .product-item'));
      if (!items.length) break;

      for (const item of items){
        if (count >= TARGET_COUNT) break;
        const link = item.querySelector('a[href*="/products/"]');
        const m = link && link.getAttribute('href').match(/\/products\/([^/?#]+)/);
        const handle = m ? m[1] : null;
        if (!handle || have.has(handle)) continue;
        have.add(handle);
        addDivider();
        item.setAttribute('data-match', '0');
        item.setAttribute('data-padded', '1');
        grid.insertAdjacentHTML('beforeend', item.outerHTML);
        count++;
      }
    }
    return count;
  }

  async function pad(){
    const have = existingHandles();
    let count = have.size;
    if (count >= TARGET_COUNT) return;

    // Try each source in priority order (vehicle-scoped first, sitewide last) until the grid
    // is full or every source is exhausted.
    for (const src of vehicleScopedSources()){
      if (count >= TARGET_COUNT) break;
      count = await fetchAndAppend(src, have, count);
    }
  }

  pad();
})();
